import { ROUNDING_MODE_OPTIONS } from '#/utils/roundingMode';
import { formatDisplayNumber } from '#/utils/formatNumber';

/** 數量、單價、列金額最多四位小數；總額為取整後 TWD 整數。 */
export function formatCostEstimateDecimal(value) {
  return formatDisplayNumber(value, { maximumFractionDigits: 4 });
}

export function formatCostEstimateTotal(value) {
  return formatDisplayNumber(value);
}

export function formatCostEstimateRoundingMode(value) {
  return ROUNDING_MODE_OPTIONS.find((option) => option.value === value)?.label ?? (value || '-');
}
